<iad-topbar-menu #iadTopBar [user]="user$ | async" [environment] = "config.topbarEnvironment" >
  <div class="content-padding" [ngClass]="{ 'open': menuOpened, 'menu-closed': !menuOpened }">
    <iad-breadcrumb></iad-breadcrumb>
    <router-outlet></router-outlet>
  </div>
</iad-topbar-menu>
